import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Contact from "./components/Contact";
import About from "./components/About";
import Hero from "./components/Hero";
import Services from "./components/Services";
import CaseStudies from "./components/CaseStudies";
import WhyUs from "./components/WhyUs";
import DefaultSEO from "./components/DefaultSEO";
// import DecisionTree from "./components/DecisionTree";
// import decisionTreeData from "./data/decisionTreeData";

function App() {
  return (
    <>
      <Router>
        <DefaultSEO />
          <Header />
            <main>
              <Routes>
                <Route path="/" element={<Hero />} />
                <Route path="/about" element={<About />} />
                <Route path="/services" element={<Services />} />
                <Route path="/case-studies" element={<CaseStudies />} />
                {/* <Route path="/interactive-guide" element={<DecisionTree data={decisionTreeData} />} /> */}
                <Route path="/why-us" element={<WhyUs />} />
                <Route path="/contact" element={<Contact />} />
              </Routes>
            </main>
          <Footer />
      </Router>
    </>
  );
}

export default App;